import React from "react";
import { twMerge } from "tailwind-merge";
import ColumnsOneIcon from "@/assets/icons/columns-one.svg";
import ColumnsTwoIcon from "@/assets/icons/columns-two.svg";
import ColumnsThreeIcon from "@/assets/icons/columns-three.svg";

export interface Props {
  currentDisplay: number;
  onDisplayChange: (id: number) => void;
  className?: string;
  allThemesWithWhiteBackground?: boolean;
}

function MasonryHeader({
  currentDisplay,
  onDisplayChange,
  className,
  allThemesWithWhiteBackground,
}: Props) {
  return (
    <div
      className={twMerge(
        "hidden md:flex justify-between items-center mb-6 md:mb-10 md:justify-end",
        className,
      )}
    >
      <div
        className={twMerge(
          "text-body-3 -tracking-tight text-grey",
          allThemesWithWhiteBackground && "endemic:text-invert text-primary",
        )}
      >
        Columns:
      </div>
      <div className="flex justify-between items-center">
        <ColumnsOneIcon
          className={twMerge(
            `ml-6 cursor-pointer`,
            currentDisplay === 1
              ? `fill-red endemic:fill-white ${allThemesWithWhiteBackground && "endemic:fill-red"}`
              : `fill-grey ${allThemesWithWhiteBackground && "endemic:fill-invert fill-primary"}`,
          )}
          onClick={() => onDisplayChange(1)}
        />
        <ColumnsTwoIcon
          className={twMerge(
            `ml-2 cursor-pointer`,
            currentDisplay === 2
              ? `fill-red endemic:fill-white ${allThemesWithWhiteBackground && "endemic:fill-red"}`
              : `fill-grey ${allThemesWithWhiteBackground && "endemic:fill-invert fill-primary"}`,
          )}
          onClick={() => onDisplayChange(2)}
        />
        <ColumnsThreeIcon
          className={twMerge(
            `ml-2 cursor-pointer`,
            currentDisplay === 3
              ? `fill-red endemic:fill-white ${allThemesWithWhiteBackground && "endemic:fill-red"}`
              : `fill-grey ${allThemesWithWhiteBackground && "endemic:fill-invert fill-primary"}`,
          )}
          onClick={() => onDisplayChange(3)}
        />
      </div>
    </div>
  );
}

export default MasonryHeader;
